import { render, staticRenderFns } from "./AbadonedCartList.vue?vue&type=template&id=621c9af8&scoped=true&"
import script from "./AbadonedCartList.vue?vue&type=script&lang=js&"
export * from "./AbadonedCartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c9af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621c9af8')) {
      api.createRecord('621c9af8', component.options)
    } else {
      api.reload('621c9af8', component.options)
    }
    module.hot.accept("./AbadonedCartList.vue?vue&type=template&id=621c9af8&scoped=true&", function () {
      api.rerender('621c9af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/AbadonedCartList.vue"
export default component.exports